module.exports = __webpack_public_path__ + "img/banner01.703f9701.gif";